<template>

    
      <v-col>
          <v-card flat>
         <v-data-table
            :key="componentKey"
            :headers="computedHeaders"
            :items="tableItems"
            class="elevation-1"
            :loading="departmentsLoadStatus===1"
            :options.sync="tableOptions"
            :server-items-length="options.lineCount"
            hide-default-footer
            must-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Placówki</v-toolbar-title>
                
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                

                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Wyszukaj"
                      single-line
                      hide-details
                      class="search"
                      @keydown.enter="searchDepartments"
                  ></v-text-field>
                  </template>
                    <span>Wpisz min 3 znaki i naciśnij Enter</span>
                </v-tooltip>
                 

                <v-spacer></v-spacer>

                <v-checkbox v-model="showDeleted" class="mt-4" label="Pokaż wyłączone"></v-checkbox>

                <v-divider
                  v-if="user.permissions['setting'] >= 10"
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                <v-dialog v-if="user.permissions['setting'] >= 10" v-model="dialog" max-width="700px">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small class="mb-2 mt-2" fab dark color="primary">
                      <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <v-card  :loading="departmentAddStatus===1 || departmentEditLoadStatus===1 || departmentEditStatus===1">
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        
                          <v-row>                   
                            <v-col cols="12" sm="10" md="10">
                              <v-text-field v-model="editedItem.name" :error-messages="nameErrors" required @input="$v.editedItem.name.$touch()"  @blur="$v.editedItem.name.$touch()" counter="20" label="Nazwa placówki"></v-text-field>                            
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                              <v-checkbox
                                :disabled="itemEditing && itemWasMain"
                                v-model="editedItem.main"
                                label="Centrala"
                              ></v-checkbox>
                              
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field v-model="editedItem.city" :error-messages="cityErrors" required @input="$v.editedItem.city.$touch()"  @blur="$v.editedItem.city.$touch()" label="Miasto"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field v-model="editedItem.street" :error-messages="streetErrors" required @input="$v.editedItem.street.$touch()"  @blur="$v.editedItem.street.$touch()" label="Adres"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <v-text-field v-model="editedItem.phone" :error-messages="phoneErrors" required @input="$v.editedItem.phone.$touch()"  @blur="$v.editedItem.phone.$touch()" label="Telefon"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row><v-col><h4>Domyślne godziny pracy</h4></v-col></v-row>
                          <v-row>
                            <v-col cols="12" sm="4" md="4">
                              <v-menu
                                ref="menuOd"
                                v-model="menuOd"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="editedItem.from"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                   v-model="editedItem.from" 
                                   :error-messages="fromErrors"  
                                   @input="$v.editedItem.from.$touch()"  
                                   @blur="$v.editedItem.from.$touch()" 
                                   label="Od godziny"
                                   prepend-icon="mdi-clock-outline"
                                   readonly
                                   v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                  v-if="menuOd"
                                  v-model="editedItem.from"
                                  full-width
                                  format="24hr"
                                  @click:minute="$refs.menuOd.save(editedItem.from)"
                                ></v-time-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                              <v-menu
                                ref="menuDo"
                                v-model="menuDo"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="editedItem.to"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                   v-model="editedItem.to" 
                                   :error-messages="toErrors"  
                                   @input="$v.editedItem.to.$touch()"  
                                   @blur="$v.editedItem.to.$touch()" 
                                   label="Do godziny"
                                   prepend-icon="mdi-clock-outline"
                                   readonly
                                   v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                  v-if="menuDo"
                                  v-model="editedItem.to"
                                  full-width
                                  format="24hr"
                                  @click:minute="$refs.menuDo.save(editedItem.to)"
                                ></v-time-picker>
                              </v-menu>
                            </v-col>
                          </v-row>
                        
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray" text @click="close">Anuluj</v-btn>
                      <v-btn color="primary darken-1" text @click="handleSubmit" >Zapisz</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-tooltip v-if="item.status && user.permissions['setting'] >= 10" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    mdi-pencil
                  </v-icon>
                  </template>
                    <span>Edytuj</span>
                </v-tooltip>

                <v-tooltip v-if="item.status && item.can_delete && user.permissions['setting'] >= 10" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class=""
                    @click="deleteItem(item)"
                  >
                    mdi-delete
                  </v-icon>
                  </template>
                  <span>Wyłącz</span>
                </v-tooltip>

                <v-tooltip v-if="!item.status  && user.permissions['setting'] >= 20" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    @click="reactivateItem(item)"
                  >
                    mdi-delete-restore
                  </v-icon>
                  </template>
                  <span>Przywróć</span>
                </v-tooltip>

                <v-tooltip v-if="!item.status && item.can_delete  && user.permissions['setting'] >= 20" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class=""
                    color="error"
                    @click="forceDeleteItem(item)"
                  >
                    mdi-delete-forever
                  </v-icon>
                  </template>
                  <span>Usuń na stałe</span>
                </v-tooltip>

                
            </template>

            <template v-slot:item.main="{ item }">
              <v-simple-checkbox v-model="item.main" disabled></v-simple-checkbox>
            </template>        

            <template v-slot:item.status="{ item }">
              <v-simple-checkbox v-model="item.status" disabled></v-simple-checkbox>
            </template>

          </v-data-table> 
          <div class="text-center pt-2">
            <v-btn @click="loadMore" v-if="!options.itemAdded && options.lineCount-tableItems.length>0 && departmentsLoadStatus===2" small color="primary"><v-icon left>mdi-download</v-icon>Załaduj więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadDepartments" v-else-if="options.itemAdded && options.lineCount-tableItems.length>0" small color="primary"><v-icon left>mdi-reload</v-icon>Odśwież tabele aby móc załadować więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadDepartments" v-else-if="options.itemSearched" small color="primary"><v-icon left>mdi-reload</v-icon>Anuluj wyszukiwanie</v-btn>
          
          </div>

          </v-card>
      
      <confirm ref="confirm"></confirm>
      </v-col>
      

</template>

<script>
  import confirm from '../components/Confirm'

  import required from 'vuelidate/lib/validators/required'
  import minLength from 'vuelidate/lib/validators/minLength'
  import maxLength from 'vuelidate/lib/validators/maxLength'
  import numeric from 'vuelidate/lib/validators/numeric'

  export default {
    components:{
      confirm
    },
    data: () => ({
      componentKey:0,
      tableOptions: {},
      dialog: false,
      itemEditing:false,
      search:'',
      itemWasMain:false,
      menuOd: false,
      menuDo: false,
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false},
        { text: 'Nazwa placówki', value: 'name',filterable:true },
        { text: 'Centrala', value: 'main',filterable:false },
        { text: 'Miasto', value: 'city',filterable:true },
        { text: 'Adres', value: 'street',filterable:true },
        { text: 'Telefon', value: 'phone',filterable:true },
        { text: 'Grup', value: 'courses_count',filterable:false },
        { text: 'Dzieci', value: 'children_count',filterable:false },
        { text: 'Status', value: 'status',filterable:false },
        { text: 'Akcje', value: 'actions', sortable: false,filterable:false },
      ],
    }),
    validations: {
      editedItem:{
        name: {
          required,
          maxLength:maxLength(20),
        },
        city:{
          required
        },
        street:{
          required
        },
        phone:{
          required
        }
      }
    },
    watch: {
      tableOptions: {
        handler () {
          var currentOptions = {...this.options};
          const { sortBy, sortDesc } = this.tableOptions
        
          //zmiana sortowania
          if (sortBy.length === 1 && sortDesc.length === 1) {
            currentOptions.orderBy = sortBy[0];
            currentOptions.orderDirection = sortDesc[0]?'desc':'asc';
            this.options = currentOptions;
          } 
        },
        deep: true,
      },
    
      dialog (val) {
        this.$v.$reset()
        val || this.close()
      },
      departmentEditStatus(val){
        if(val===2){
          this.close();
          this.componentKey += 1;
        }
      },
      departmentAddStatus(val){
        if(val===2){
          this.close();
          this.componentKey += 1;
        }
      },
      departmentDeleteStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      }
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      options:{
        get () {  
          return this.$store.getters.getDepartmentOptions;
        },
        set (value) {
          this.search='';
          this.$store.dispatch( 'setDepartmentOptions', {options:value} )
        }
      },
      showDeleted: {
        get () {
          return this.$store.getters.getDepartmentOptions.showDeleted;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.showDeleted = value;
          this.options = currentOptions;
        }
      },
      editedItem(){
        return this.$store.getters.getDepartmentEdit;
      },
      tableItems(){
        return this.$store.getters.getDepartments;
      },
      departmentsLoadStatus(){
        return this.$store.getters.getDepartmentsLoadStatus;
      },
      departmentEditLoadStatus(){
        return this.$store.getters.getDepartmentEditLoadStatus
      },
      departmentEditStatus(){
        return this.$store.getters.getDepartmentEditStatus();
      },
      departmentEditText(){
        return this.$store.getters.getDepartmentEditText
      },
      departmentAddStatus(){
        return this.$store.getters.getDepartmentAddStatus();
      },
      departmentAddText(){
        return this.$store.getters.getDepartmentAddText;
      },
      departmentDeleteStatus(){
        return this.$store.getters.getDepartmentDeleteStatus();
      },
      computedHeaders () {
        if(!this.showDeleted && this.user.permissions['setting'] <= 5) return this.headers.filter(h => h.value!=='status' && h.value!=='actions')
        else if(this.showDeleted && this.user.permissions['setting'] <= 5) return this.headers.filter(h => h.value!=='actions')
        else if(!this.showDeleted) return this.headers.filter(h => h.value!=='status')
        else return this.headers
      },
      formTitle () {
        return !this.itemEditing ? 'Nowa placówka' : 'Edycja placówki'
      },
      nameErrors () {
        const errors = []
        if (!this.$v.editedItem.name.$dirty) return errors
        !this.$v.editedItem.name.required && errors.push('Nazwa jest wymagana')
        !this.$v.editedItem.name.maxLength && errors.push('Nazwa może mieć maksymalnie 20 znaków')
        return errors
      },
      cityErrors () {
        const errors = []
        if (!this.$v.editedItem.city.$dirty) return errors
        !this.$v.editedItem.city.required && errors.push('Miasto jest wymagane')
        return errors
      },
      streetErrors () {
        const errors = []
        if (!this.$v.editedItem.street.$dirty) return errors
        !this.$v.editedItem.street.required && errors.push('Adres jest wymagany')
        return errors
      },
      phoneErrors () {
        const errors = []
        if (!this.$v.editedItem.phone.$dirty) return errors
        !this.$v.editedItem.phone.required && errors.push('Telefon jest wymagany')
        //!this.$v.editedItem.phone.numeric && errors.push('Telefon może zawierać tylko cyfry')
        return errors
      },
    },
    mounted(){
      this.loadDepartments();
    },
    methods: {
      loadDepartments(){
        this.search='';
        this.$store.dispatch( 'loadDepartments' );
      },
      loadMore(){
        this.$store.dispatch( 'loadMoreDepartments' );
      },
      reactivateItem(item){
        this.$store.dispatch( 'editDepartmentReactivate',{slug:item.id});
      },
      editItem (item) {
        this.itemWasMain = item.main;
        this.itemEditing = true
        this.$store.dispatch( 'loadDepartmentEdit', {slug:  item.id});  
        this.dialog = true
      },
      deleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz wyłączyć placówkę?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'deleteDepartment', {slug:  item.id});
            }
        })
      },
      forceDeleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz usunać placówkę na stałe?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'forceDeleteDepartment', {slug:  item.id});
            }
        })
      },
      searchDepartments(){
        if(this.search.length>2){
          const filterableHeaders = _.join(_.map(_.filter(this.headers,{'filterable':true}),'value'),';');
          this.$store.dispatch( 'searchDepartments',{filterableHeaders:filterableHeaders,q:this.search});
        }
      },
      close () {
        this.dialog = false
        this.$v.$reset()
        setTimeout(() => {
          this.$store.dispatch( 'loadDepartmentEditDefault'); 
          this.$store.dispatch( 'loadDepartmentAddDefault');
          this.itemEditing = false
        }, 300)
      },
      handleSubmit () {
        this.$v.$touch()
        if (this.$v.$invalid) {

        } else {
         
            if (this.itemEditing) {
              //edycja
              this.$store.dispatch( 'editDepartment', {
                slug: this.editedItem.id,
                name:  this.editedItem.name,
                city:  this.editedItem.city,
                street:  this.editedItem.street,
                phone:  this.editedItem.phone,
                main:  this.editedItem.main, 
                from:  this.editedItem.from,
                to:  this.editedItem.to, 
              });
            } else {//new item
              this.$store.dispatch( 'addDepartment', {
                  name:  this.editedItem.name,
                  city:  this.editedItem.city,
                  street:  this.editedItem.street,
                  phone:  this.editedItem.phone,
                  main:  this.editedItem.main,
                  from:  this.editedItem.from,
                  to:  this.editedItem.to, 
              });

            }
        }
      },
    },
  }
</script>


<style scoped>
.search{
      max-width: 250px;
}
</style>